// @flow

export const Percentage = (value: any) => (parseFloat((value || 0) * 100).toFixed(2) + '%')
